import { z } from 'zod'

export const registrationSchema = z.object({
  fullName: z
    .string()
    .min(2, 'Name must be at least 2 characters')
    .trim()
    .nonempty('Full name is required'),

  building: z.string().nonempty('Building is required'),

  otherBuilding: z.string().optional(),

  wingFlat: z.string().trim().nonempty('Wing/Flat is required'),

  mobileNumber: z
    .string()
    .regex(/^[0-9]{10}$/, 'Mobile number must be exactly 10 digits'),

  dob: z.date({
    required_error: 'Date of birth is required',
  }).refine(
    (date) => date < new Date(),
    'Date of birth cannot be in the future'
  ),

  gender: z.enum(['Male', 'Female'], {
    required_error: 'Gender is required',
  }),

  tshirtSize: z.string().nonempty('T-shirt size is required'),

  tshirtNumber: z
    .string()
    .regex(/^[0-9]{1,2}$/, 'Jersey number must be 1-2 digits'),

  tshirtName: z.string().trim().nonempty('Name on T-shirt is required'),

  selectedSportIds: z
    .array(z.number())
    .min(1, 'Please select at least one sport'),

  sportsExpertise: z.string().optional(),

  profilePhoto: z.instanceof(File).optional(),

  paymentScreenshot: z.instanceof(File).optional(),
}).refine(
  (data) => {
    if (data.building === 'Other') {
      return !!data.otherBuilding && data.otherBuilding.trim().length > 0
    }
    return true
  },
  {
    message: 'Please specify building name',
    path: ['otherBuilding'],
  }
)

export type RegistrationFormSchema = z.infer<typeof registrationSchema>
